import request from '@/utils/request'

// 引入
// import touristApi from '@/api/system/tourist/tourist.js'

// 使用
// touristApi.houseCustomTagList().then((res) => {
//   if (res.code == 200) {
//     this.$message.success('查询房源自定义标签列表')
//     this.customTagList = res.data
//   }
// })

export default {

  // // 批量删除房源信息(暂无此功能)
  // deleteHouse(data) {
  //   // console.log(data);
  //   return request({
  //     url: `/houseInfo/${data}`,
  //     method: 'delete',

  //   })
  // },

  // 新增客源需求信息
  touristAdd (data) {
    // console.log(data, '客源');
    return request({
      url: '/lesseeRequirement',
      method: 'post',
      data: data
    })
  },
  // 修改客源需求信息
  touristPut (data) {
    return request({
      url: '/lesseeRequirement',
      method: 'put',
      data: data
    })
  },

  // 查询房源自定义标签列表
  houseCustomTagList (query) {
    // console.log('查询房源自定义标签列表', query);
    return request({
      url: '/houseCustomTag/list',
      method: 'get',
      params: query
    })
  },
  // 查询客源需求列表
  lesseeRequirementList (query) {
    // console.log('查询客源需求列表', query);
    return request({
      url: '/lesseeRequirement/list',
      method: 'get',
      params: query
    })
  },
  // 区域列表
  district (query) {
    // console.log('区域列表', query);
    return request({
      url: '/district/list',
      method: 'get',
      params: query

    })
  },
  // 商圈列表
  businessDistrict (query) {
    // console.log('商圈列表', query);
    return request({
      url: '/businessDistrict/list',
      method: 'get',
      params: query

    })
  },
  // 查询街道列表
  GetStreetList (query) {
    // console.log('查询街道列表', query);
    return request({
      url: '/street/list',
      method: 'get',
      params: query

    })
  },
  // 获取客源详情信息
  touristDetails (id) {
    return request({
      url: `/lesseeRequirement/${id}`,
      method: 'get'

    })
  },
  // 租客，私客转公客
  updateRentDishTypePrivateToCompany (id) {
    return request({
      url: `/lesseeRequirement/updateLesseeDishTypePrivateToCompany/${id}`,
      method: 'get'

    })
  },
  // 售客，私客转公客
  updateSellDishTypePrivateToCompany (id) {
    return request({
      url: `/houses/lesseeRequirementSale/updateLesseeDishTypePrivateToCompany/${id}`,
      method: 'get'

    })
  },
  // 获取客源动态记录列表
  getRecordList (query) {
    return request({
      url: `/lesseeTrendsRecord/list`,
      method: 'get',
      params: query

    })
  },
  // 新增跟进记录
  followUpAdd (data) {
    return request({
      url: '/followUpRecord/add',
      method: 'post',
      data: data
    })
  },

  // 新增认领记录
  receiveRecordAdd (data) {
    return request({
      url: '/receiveRecord/add',
      method: 'post',
      data: data
    })
  },
  // 新增面访记录
  interviewRecordAdd (data) {
    return request({
      url: '/houses/interviewRecord',
      method: 'post',
      data: data
    })
  },
  // 新增带看记录
  takeLookRecordAdd (data) {
    return request({
      url: '/houses/takeLookRecord',
      method: 'post',
      data: data
    })
  },
  // 修改客源需求信息标识（1：五，3：优，6:暂缓）
  editIdentity (data) {
    return request({
      url: '/lesseeRequirement/update/identity',
      method: 'put',
      data: data
    })
  },
  // 转维护人
  toMaintainer (data) {
    return request({
      url: '/lesseeRequirement/update/accendant',
      method: 'put',
      data: data
    })
  },
  // 点亮-取消点亮意向
  identityWill (data) {
    return request({
      url: '/lesseeRequirement/update/will',
      method: 'put',
      data: data
    })
  },

  // 查询房源信息列表
  gethouseInfoList (query) {
    return request({
      url: `/houseInfo/list`,
      method: 'get',
      params: query

    })
  },
  // 获取部门团队列表
  getDeptList (query) {
    return request({
      url: '/system/dept/list',
      method: 'get',
      params: query

    })
  },
  // 获取用户列表
  getUserList (query) {
    return request({
      url: '/system/user/list',
      method: 'get',
      params: query

    })
  },

  // 获取上级列表
  querySuperior (query) {
    return request({
      url: '/system/dept/querySuperior',
      method: 'get',
      params: query

    })
  },
  // 获取上级头像
  getAvater (leaderId) {
    return request({
      url: `/system/user/getUserInfo/${leaderId}`,
      method: 'get'

    })
  },

  // 根据客户需求ID查询客户信息
  getRequirement (query) {
    return request({
      url: `/lesseeInfo/requirement/getByRequirementId`,
      method: 'get',
      params: query
    })
  },

  // 查询相关人员信息列表
  personList (query) {
    return request({
      url: `/relatedPersonnelInfo/list`,
      method: 'get',
      params: query
    })
  },

  // 查看客源信息是否存在
  existsSearch (data) {
    return request({
      url: '/lesseeInfo/get/lessee/exists',
      method: 'post',
      data: data
    })
  },

  // 查询带看记录列表
  takeLookRecord (query) {
    return request({
      url: `/houses/takeLookRecord/list`,
      method: 'get',
      params: query
    })
  },

  // 查询行业分类列表
  industryCategory (query) {
    return request({
      url: `/setting/industryCategory/list`,
      method: 'get',
      params: query
    })
  },

  // 客源一键同步
  synchronization (data) {
    return request({
      url: '/houses/lesseeRequirementSale/edit/synchronization',
      method: 'put',
      data: data
    })
  },

  // 详情-历史成交-----------------------------------------------

  // 查询合同信息列表
  contractsInfo (query) {
    return request({
      url: `/contractsInfo/list`,
      method: 'get',
      params: query
    })
  },

  /**
   * 获取创建人列表
   */
  getCreateByUserOptions () {
    return request({
      url: '/system/user/getCreateByUserOptions',
      method: 'get'
    })
  }

}
